import { CheckCircleFillIcon } from '@primer/octicons-react'
import format from 'date-fns/format'

import Button from '../common/Button/Button'

import { text } from '../../constants/colors.constants'

import LoadingDots from '../common/LoadingDots/LoadingDots'

const ButtonStyle = {
  border: 'none',
  background: '#FFFFFF',
  boxShadow: 'none',
  textDecoration: 'underline',
  lineHeight: '12px',
  color: text.mainBlue,
  fontWeight: '400',
  paddingLeft: '0px',
  paddingRight: '0px',
  marginLeft: '0.5rem'
}

export const PublishStatusMessage = ({
  handlePipelinePublishStatusFetch,
  status,
  data
}) => {
  if (status === 'Publishing' || status === 'PendingPublish') {
    return (
      <div className="flex">
        Publishing Package
        <LoadingDots />
      </div>
    )
  }

  if (status === 'Error') {
    return (
      <div className="flex">
        Error publishing
      </div>
    )
  }

  if (status === 'Published') {
    return (
      <div className="flex">
        <CheckCircleFillIcon size={12} fill="#22C55E" className="mt-1 mr-1"/>
        {`Published at ${format(new Date(data?.updated_at.split('.')[0]), 'MM/dd/yyyy HH:mm:ss')}`}
        <Button sx={ButtonStyle} onClick={() => handlePipelinePublishStatusFetch(data?.id)}>
          Check Info
        </Button>
      </div>
    )
  }

  return null
}

export default PublishStatusMessage
